<template lang="pug">
.container(id="AddExtensionForm-container")
  h4 {{$t('Add new or upgrade an Extension')}}
  hr.header
  el-form.form-container(id="AddExtensionForm-form" :action='uploadUrl', ref='upload', label-width="100px", method="post", enctype="multipart/form-data")
    .form-row
      el-form-item(:label="$t('Name')")
        el-input.el-input(id="AddExtensionForm-formNameInput" v-model='params.name', type="text", name="name", ref="name", style="width: 250px;", :placeholder="$t('name')", @input='changedName',
          :disabled='upgradedExtension.id > 0'
        )
      el-form-item(:label="$t('Description')")
        el-input.el-input(id="AddExtensionForm-formDescriptionInput" v-model='params.description', type="textarea", name="description", ref="description", style="width: 450px;", :rows="5", :placeholder="$t('description')")
    .form-row
      el-form-item(:label="$t('Version')")
        el-input.el-input(id="AddExtensionForm-formVersionInput" v-model='params.version', type="text", name="version", ref="version", style="width: 250px;", :placeholder="$t('version')", @input='resetErrors')
      el-form-item(:label="$t('Playlist')")
        el-switch(id="AddExtensionForm-formIsPlaylistSwitch" v-model='params.isPlayListExtension', :active-text='$t("yes")', :inactive-text='$t("no")',
          :disabled='upgradedExtension.id > 0', @input='resetErrors'
        )
    .form-row
      el-form-item(:label="$t('Scope')")
        el-switch(id="AddExtensionForm-formIsGlobalSwitch" v-model='params.isGlobalExtension', :active-text='$t("global")', :inactive-text='$t("local")',
          :disabled='upgradedExtension.id > 0', @input='resetErrors'
        )
      el-form-item(label="")
        el-button(id="AddExtensionForm-formUploadButton" size='small', type='success', plain,  @click='selectFile("Js")')
          span {{$t('browse')}} &nbsp;
          font-awesome-icon(icon="folder-open")
        span(v-if='file') &nbsp; {{ file.name }}
        span.muted(v-else) &nbsp; {{ $t('select .zip with schema.json and index.dist.js') }}
    .form-row.float-right
      el-button(id="AddExtensionForm-formSubmit" size='small', type='success', @click='submitUpload', :disabled='!formValidated()')
        span {{ uploading ? $t('uploading extension...') : $t('upload')}} &nbsp;
        font-awesome-icon(icon="upload")
    input.hidden(ref='selectZip', id="AddExtensionForm-fileInput", type='file', name='file', accept=".zip", @change='updateFileList()')
    .error(v-if='errors.length > 0')
      span {{ $t('Could not parse .zip file') }}.&nbsp;
      p
        strong {{ $t('Server response') }} - {{ errors[0].response.data }}
  p.advice(v-if='exisitingExtensions.length > 0 && errors.length === 0') {{ $t('Some extensions found with similar name. If you want to upgrade an extension, please click on one of them. Remember to adjust version afterwards.')}}
  .existing-extension-section(v-if='exisitingExtensions.length > 0 && errors.length === 0')
    .existing-extension-row
      .cell.header.name {{ $t('Name')}}
      .cell.header.version {{ $t('Version')}}
      .cell.header.description {{ $t('Description')}}
      .cell.header.global {{ $t('Global/Network')}}
  .existing-extension-section(v-if='exisitingExtensions.length > 0 && errors.length === 0')
    .existing-extension-row(
      v-for='exisitingExtension of exisitingExtensions',
      :key='exisitingExtension.id',
      @click="toggleSelectExistingExtension(exisitingExtension)",
      :class="{ 'isSelected': exisitingExtension.id === upgradedExtension.id }",
    )
      .cell.name {{ exisitingExtension.name }}
      .cell.version {{ exisitingExtension.version }}
      .cell.description {{ exisitingExtension.description }}
      .cell.global
        font-awesome-icon(v-if='exisitingExtension.Network < 1', icon="globe")
        span(v-else) {{ exisitingExtension.networkName }}
  </template>

<script>
import Vue from 'vue'
import semver from 'semver'
import textUtils from './../Common/textUtils.mixin'
import userUtils from './../Common/userUtils.mixin'

export default {
  mixins: [textUtils, userUtils],
  props: ['side', 'folder'],
  created () {
    this.params.isGlobalExtension = !!this.isAdminOrSuperAdmin
  },
  data () {
    return {
      uploadUrl: this.apiUrl('file/extensionUpload'),
      file: null,
      errors: [],
      uploading: false,
      params: {
        name: null,
        description: null,
        version: '0.1.0',
        isPlayListExtension: false,
        isGlobalExtension: false
      },
      exisitingExtensions: [],
      upgradedExtension: { id: null }
    }
  },
  watch: {
    params: async function (newParams, oldParams) {
      if (JSON.stringify(newParams) !== JSON.stringify(oldParams)) {
        this.errors = []
      }
    }
  },
  methods: {
    resetErrors () {
      this.errors = []
    },
    toggleSelectExistingExtension (extension) {
      if (this.upgradedExtension && this.upgradedExtension.id === extension.id) {
        this.upgradedExtension = { id: null }
        return
      }
      this.upgradedExtension = extension
      this.params.name = extension.name
      this.params.description = extension.description !== 'null' ? extension.description : ''
      this.params.version = semver.inc(extension.version, 'minor')
      this.params.isPlayListExtension = extension.isPlayListExtension
      this.params.isGlobalExtension = extension.Network < 1
      this.$refs.version.focus()
    },
    async changedName (val) {
      this.resetErrors()
      if (val.length < 3) return
      this.exisitingExtensions = (await Vue.axios.get(`extension/getAdminMaxVersions?namesubstring=${val}`)).data
    },
    formValidated () {
      return this.file && !this.uploading && this.params.name.length >= 3
    },
    selectFile () {
      this.$refs[`selectZip`].click()
    },
    submitUpload () {
      const formData = new FormData()
      formData.append('name', this.params.name)
      formData.append('description', this.params.description ? this.params.description : '')
      formData.append('version', semver.coerce(this.params.version))
      formData.append('isPlayListExtension', this.params.isPlayListExtension)
      formData.append('isGlobalExtension', this.params.isGlobalExtension)
      formData.append('file', this.file)
      this.uploading = true
      Vue.axios.post(this.uploadUrl,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(response => {
        this.uploading = false
        this.$emit('close')
      }).catch(e => {
        this.$store.dispatch('Error/setAxiosError', e.response)
        this.errors = []
        this.errors.push(e)
        this.uploading = false
      })
    },
    updateFileList (type) {
      this.file = this.$refs[`selectZip`].files[0]
    }
  },
  computed: {

  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  .advice {
    color: $--color-text-secondary;
    text-align: center;
    margin: 40px 0px;
  }
  .el-form-item {
    width: 600px;
  }
  .hidden {
    visibility: hidden;
  }
  .error {
    color: $--color-warning;
  }
  .form-container {
    padding-top: 50px;
    width: 50%;
    margin: auto;
  }
  .existing-extension-section {
    display: flex;
    align-items: center;
    flex-direction: column;
    .existing-extension-row {
      display: flex;
      min-height: 30px;
      align-items: center;
      border-bottom: $--border-light;
      &.isSelected {
        background-color: $--background-color-selected;
      }
      .cell {
        font-size: $--font-size-base;
        padding: 10px;
        &.header {
          color: $--color-text-secondary;
        }
        &.name {
          width: 160px;
        }
        &.description {
          width: 750px;
        }
        &.version {
          width: 50px;
        }
        &.global {
          width: 150px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Medium/AddExtensionForm.vue